<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="frame">
  <div class="table-container">
    <table mat-table #teamAppTable [dataSource]="teamDataSource" multiTemplateDataRows>
      <!-- name column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="column-name">Team</th>
        <td mat-cell *matCellDef="let element" class="column-name">
          {{ element.shortName }} - {{ element.name }}
        </td>
      </ng-container>
      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div [@detailExpand]="element.id == expandedElementId ? 'expanded' : 'collapsed'" style="overflow: hidden">
            @if (expandedElementId === element.id) {
            <div class="expanded-detail-div">
              <div class="data-panel">
              <div class="data-row">
                <div class="left-order">
                  <h4 style="margin-left: 25px;">Display Order</h4>
                </div>
                <div class="right-name">
                  <h4>Application</h4>
                </div>
              </div>
            </div>
            <div class="data-panel">
              @for (playerApplicationTeam of getTeamApplications(element.id); track playerApplicationTeam.id) {
              <div class="data-row">
                <div class="left-order">
                  <div class="left-buttons">
                    <button mat-icon-button (click)="moveUp(playerApplicationTeam); $event.stopPropagation();"
                      style="outline: none; margin-left: 15px;" title="Move player application up"
                      [disabled]="!canEdit || +playerApplicationTeam.displayOrder === 1">
                      <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-up"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="moveDown(playerApplicationTeam); $event.stopPropagation();"
                      style="outline: none; margin-left: 15px;" title="Move player application down"
                      [disabled]="!canEdit || +playerApplicationTeam.displayOrder >= getTeamApplications(element.id).length">
                      <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-down"></mat-icon>
                    </button>
                  </div>
                  <div class="left-value">{{ playerApplicationTeam.displayOrder }}</div>
                </div>
                <div class="right-name">
                  {{ getApplicationName(playerApplicationTeam.playerApplicationId) }}
                </div>
              </div>
              }
            </div>
            </div>
            }
          </div>
        </td>
      </ng-container>
      <!-- row definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="getRowClass(row.id)"
        (click)="rowClicked(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
  </div>
</div>
